import { get } from "src/services/api";
import { FETCH_QUERY_KEYS } from "src/queries/consts";
import { useQuery } from "@tanstack/react-query";

const SIGMA_EMBED_REFRESH_LEAD_MS = 60 * 1000;
const SIGMA_EMBED_MIN_REFRESH_MS = 1000;
const SIGMA_EMBED_MAX_RETRIES = 3;

const isClientError = (error) => {
  const status = error?.response?.status;
  return status >= 400 && status < 500;
};

const sigmaEmbedUrlEndpoint = (assistantId, key) => `assistants/${assistantId}/sigma/insights/dashboards/${key}/embed-url`;

export const getSigmaEmbedRefreshInterval = (expiresAt) => {
  if (!expiresAt) return false;
  const remainingMs = new Date(expiresAt).getTime() - Date.now();
  return Math.max(remainingMs - SIGMA_EMBED_REFRESH_LEAD_MS, remainingMs / 2, SIGMA_EMBED_MIN_REFRESH_MS);
};

export const isSigmaEmbedExpiring = (expiresAt) =>
  !expiresAt || new Date(expiresAt).getTime() - Date.now() <= SIGMA_EMBED_REFRESH_LEAD_MS;

// Embed URLs are single use and the Sigma session will stop at `expiresAt` and an updated URL is fetched.
export const useSigmaEmbedUrl = (assistantId, key) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.SIGMA_EMBED_URL, assistantId, key],
  queryFn: async ({ signal }) => await get({ endpoint: sigmaEmbedUrlEndpoint(assistantId, key), signal }),
  enabled: !!assistantId && !!key,
  retry: (failureCount, error) => !isClientError(error) && failureCount < SIGMA_EMBED_MAX_RETRIES,
  gcTime: 0,
  staleTime: 0,
  refetchOnWindowFocus: (query) => isSigmaEmbedExpiring(query.state.data?.expiresAt),
  refetchInterval: (query) => getSigmaEmbedRefreshInterval(query.state.data?.expiresAt)
});
